/**
 * Resolve subject/unit/topic display names to database IDs.
 * Matches by exact name or "CODE NAME" format (case-insensitive).
 */

export const resolveSubject = (displayName, subjects) => {
  if (!displayName || !subjects?.length) return null;
  const sLower = displayName.toLowerCase();
  return subjects.find(s => {
    const nameLower = s.name?.toLowerCase() || '';
    const dn = s.code ? `${s.code} ${s.name}`.toLowerCase() : nameLower;
    return nameLower === sLower || dn === sLower;
  }) || null;
};

export const resolveUnit = (displayName, units, subjectId) => {
  if (!displayName || !units?.length) return null;
  const uLower = displayName.toLowerCase();
  return units.find(u => {
    const nameLower = u.name?.toLowerCase() || '';
    const dn = u.code ? `${u.code} ${u.name}`.toLowerCase() : nameLower;
    const nameMatch = nameLower === uLower || dn === uLower;
    return nameMatch && (!subjectId || u.subjectId === subjectId);
  }) || null;
};

export const resolveTopic = (displayName, topics, unitId) => {
  if (!displayName || !topics?.length) return null;
  const tLower = displayName.toLowerCase();
  return topics.find(t => {
    const nameLower = t.name?.toLowerCase() || '';
    const dn = t.code ? `${t.code} ${t.name}`.toLowerCase() : nameLower;
    const nameMatch = nameLower === tLower || dn === tLower;
    return nameMatch && (!unitId || t.unitId === unitId);
  }) || null;
};
